module.exports = __webpack_public_path__ + "img/house-chimney-blank.20d5cc93.svg";